import { render, staticRenderFns } from "./YzTab.vue?vue&type=template&id=0adcdfe3&scoped=true&lang=pug&"
import script from "./YzTab.vue?vue&type=script&lang=js&"
export * from "./YzTab.vue?vue&type=script&lang=js&"
import style0 from "./YzTab.vue?vue&type=style&index=0&id=0adcdfe3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adcdfe3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab})
